import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/${hash}`);
    }
  };

  const navLinks = [
    { label: 'Hizmetler', hash: '#services' },
    { label: 'Portföy', hash: '#portfolio' },
    { label: 'Teknoloji', hash: '#technology' },
    { label: 'Referanslar', hash: '#testimonials' },
    { label: 'İletişim', hash: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/09a8ead7418a68887e61601399480989/f761e44d359e887ba9b77959d97e14a2.png"
              alt="Bioetiket - Profesyonel Etiket Basım"
              className="h-12 w-auto"
              width="120"
              height="48"
              loading="eager"
              decoding="async"
            />
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(({ label, hash }) => (
              <a
                key={hash}
                href={`/${hash}`}
                onClick={(e) => handleAnchorClick(e, hash)}
                className={`text-sm font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-gray-800 hover:text-[#FF6B35]'
                }`}
              >
                {label}
              </a>
            ))}
            <Link
              to="/blog"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-gray-800 hover:text-[#FF6B35]'
              }`}
            >
              Blog
            </Link>
          </div>

          {/* CTA Button */}
          <a
            href="#contact"
            onClick={(e) => handleAnchorClick(e, '#contact')}
            className="hidden md:inline-flex items-center px-6 py-3 text-sm font-semibold text-white bg-[#FF6B35] rounded-full hover:bg-[#E55A2B] transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Hızlı Teklif Al
            <i className="ri-arrow-right-line ml-2"></i>
          </a>

          {/* Mobile Menu Button */}
          <button className="md:hidden w-10 h-10 flex items-center justify-center">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-gray-800'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
